// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ti1[data-v-c4adb63e]{font-size:16px;color:#303133}", ""]);
// Exports
module.exports = exports;
